// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 手机号验证码发送
export function sendPhonCode(data) {
  return request({
    url: "/api/login/send_phone_code",
    method: "post",
    data,
  });
}

// 邮箱验证码发送
export function emailLogin(data) {
  return request({
    url: "/api/login/send_email_code",
    method: "post",
    data,
  });
}


// 找回密码发送验证码
export function forgetPasswordCode(data) {
  return request({
    url: "/api/login/forget_password_code",
    method: "post",
    data,
  });
}


// 找回密码
export function forgetPassword(data) {
  return request({
    url: "/api/login/forget_password",
    method: "post",
    data,
  });
}

// 登录验证码发送
export function setLoginCode(data) {
  return request({
    url: "/api/login/set_login_code",
    method: "post",
    data,
  });
}


// 手机验证码登录
export function codeLogin(data) {
  return request({
    url: "/api/login/code_login",
    method: "post",
    data,
  });
}
